import { Navigation } from '../navigation';

const Footer = () => {
  return (
    <footer className="bg-magical-moonlight-s w-full h-16 px-2 flex items-center justify-between rounded-t-3xl fixed bottom-0 z-(--z-docked)">
      <Navigation isFooter />
    </footer>
  );
};

export { Footer };
